module.exports = __webpack_public_path__ + "static/media/QuestionMark_72dpi.179192b7.png";